import { createContext } from "react";
import { ProjectViewModel } from "../ViewModel/ProjectViewModel";
import { RouteEditTab } from "./RouteEditTab";
import { SpdrClientViewModel } from "../ViewModel/SpdrClientViewModel";
import { PdsrClientViewModel } from "../ViewModel/PdsrClientViewModel";

export interface ProjectStateType {
  readonly project: ProjectViewModel;
  readonly setProject: (updateProject: ProjectViewModel) => void;
}

interface SelectedRouteEditTabType {
  readonly routeEditTabSelected: RouteEditTab;
  readonly setRouteEditTabSelected: (
    routeEditTabSelected: RouteEditTab
  ) => void;
}

interface SelectedLtlSpdrOrPdsrType {
  readonly selectedLtlSpdrOrPdsr:
    | SpdrClientViewModel
    | PdsrClientViewModel
    | undefined;
  readonly setSelectedLtlSpdrOrPdsr: (
    spdrOrPdsr: SpdrClientViewModel | PdsrClientViewModel | undefined
  ) => void;
}

export interface stopDataOfSpdrsOrPdsrsChangedType {
  readonly stopDataOfSpdrsOrPdsrs: Array<number>;
  readonly setStopDataOfSpdrsOrPdsrs: (spdrsOrPdsrs: Array<number>) => void;
}

export interface EditProjectContextProps
  extends ProjectStateType,
    SelectedRouteEditTabType,
    stopDataOfSpdrsOrPdsrsChangedType,
    SelectedLtlSpdrOrPdsrType {
  readonly reloadData: () => Promise<void> | void;
}

export const EditProjectContext = createContext<EditProjectContextProps>({
  project: {},
  setProject: () => undefined,
  reloadData: () => undefined,
  routeEditTabSelected: RouteEditTab.Ftl,
  setRouteEditTabSelected: () => undefined,
  stopDataOfSpdrsOrPdsrs: [],
  setStopDataOfSpdrsOrPdsrs: () => undefined,
  selectedLtlSpdrOrPdsr: undefined,
  setSelectedLtlSpdrOrPdsr: () => undefined,
});
